import {Injectable, Inject} from 'ng-metadata/core';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {UserSessionManagerService} from '../../../security/userSessionManager.service';
import {SearchService} from '../../search.service';
import {FavoritesService} from "../../../favorites/favorites.service";
import {BrowseSearchService} from "../../browse/browseSearch.service";
import {SearchFieldsService} from "../../search.fields.service";
import {CollectionGalleryService} from "../../../collectionDiscovery/collectionGallery/collectionGallery.service";
import {ReportProblemService} from "../../../reportProblem/reportProblem.service";
const differenceWith = require('lodash/differenceWith');
const isEqual = require('lodash/isEqual');
const isArray = require('lodash/isArray');


@Injectable()
export class SkipToService {
    private skipLinksObject = {};
    private signedInOnlyLabels = ['favoritesLabels'];
    private withSearchResultsLabels = ['facets', 'mainResults', 'favoritesLabels'];
    private withSimpleSearchLabels = ['advanced-search'];
    private withAdvancedSearchLabels = ['searchBar'];
    private withSortAndSearchLabels = ['searchWithinInput'];
    private withReportProblemLabels = ['reportProblem'];

    constructor(private userSessionManagerService: UserSessionManagerService,
                private searchService: SearchService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private favoritesService: FavoritesService,
                private browseSearchService: BrowseSearchService,
                private searchFieldsService: SearchFieldsService,
                private collectionGalleryService: CollectionGalleryService,
                private reportProblemService: ReportProblemService) {
        this.skipLinksObject[STATE_NAMES.SEARCH] = ['mainMenu', 'searchBar', 'advanced-search', 'mainResults', 'facets','reportProblem'];
        this.skipLinksObject[STATE_NAMES.JOURNAL_SEARCH] = ['mainMenu', 'searchBarJournal', 'mainResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.FAVORITES] = ['mainMenu', 'searchBar', 'advanced-search', 'mainResults', 'favoritesLabels','reportProblem'];
        this.skipLinksObject['account'] = ['mainMenu', 'accountoverview','reportProblem'];
        this.skipLinksObject[STATE_NAMES.CITATION_TRAILS] = ['mainMenu', 'citationTrail', 'mainResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.CITATION_CHAPTERS] = ['mainMenu', 'mainResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.CITATION_LINKER] = ['mainMenu', 'citationLinker','reportProblem'];
        this.skipLinksObject[STATE_NAMES.TAGS] = ['mainMenu', 'searchBarTags', 'tags','reportProblem'];
        this.skipLinksObject[STATE_NAMES.NEWSPAPERS] = ['mainMenu', 'searchBar', 'mainResults', 'facets','reportProblem'];
        this.skipLinksObject[STATE_NAMES.BROWSE_SEARCH] = ['mainMenu', 'searchBarBrowse', 'mainResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.DB_SEARCH] = ['mainMenu', 'searchBarJournal', 'mainResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.COLLECTION_DISCOVERY] = ['mainMenu', 'searchWithinInput', 'mainCollResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.ORGANIZATION_LIST] = ['mainMenu', 'searchBarJournal', 'mainResults','reportProblem'];
        this.skipLinksObject[STATE_NAMES.AUTHORITY_SEARCH] = ['mainMenu', 'searchBarAuthority', 'mainResults','reportProblem'];
    }


//different skip links gust/user

    get skipLinks() {
        let skipLinks = this.skipLinksObject[this.$state.current.name];
        if (this.userSessionManagerService.isGuest()) {
            skipLinks = differenceWith(skipLinks, this.signedInOnlyLabels, isEqual);
        }
        if (!this.hasSearchResults()) {
            skipLinks = differenceWith(skipLinks, this.withSearchResultsLabels, isEqual);
        }
        if (this.getAdvancedSearch()) {
            skipLinks = differenceWith(skipLinks, this.withAdvancedSearchLabels, isEqual);
        } else {
            skipLinks = differenceWith(skipLinks, this.withSimpleSearchLabels, isEqual);
        }
        if (this.hasSortAndSearch()) {
            skipLinks = differenceWith(skipLinks, this.withSortAndSearchLabels, isEqual);
        }
        if(this.hasReportProblem()){
            skipLinks = differenceWith(skipLinks, this.withReportProblemLabels, isEqual);
        }
        return skipLinks;
    }

//different skip links gust/user - End


    getStateSkipLinksArray() {
        let arr = ['searchBar', 'navigation'];
        this.hasSearchResults() && arr.push('mainResults', 'facets');
        return arr;
    }

    private hasSearchResults(): boolean {
        let items;
        if (this.$state.current.name === STATE_NAMES.FAVORITES) {
            items = this.favoritesService.getItems();
        } else if (this.$state.current.name === STATE_NAMES.BROWSE_SEARCH) {
            items = this.browseSearchService.browseResult;
        } else {
            items = this.searchResults;
        }
        return isArray(items) && items.length > 0;
    }

    private get searchResults() {
        return this.searchService.getResultObject().data;
    }

    // If Advanced search is open
    public getAdvancedSearch() {
        return this.searchFieldsService.advancedSearch;
    }

    // If has gallery lobby
    public hasSortAndSearch() {
        return this.collectionGalleryService.isGalleryLobby;
    }

    private hasReportProblem() {
        return !this.reportProblemService.isReportProblem();
    }
}

//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/skipTo/skipTo.service.ts